
const windowWidth1 = window.innerWidth;

document.addEventListener('DOMContentLoaded', (event) => {
  
  const welcome = document.querySelector(".welcome");
  if (welcome != null) {
    document.querySelector(".aniBG--main").classList.add('visible');
    
    setTimeout(() => {
      document.querySelector(".welcome__title").classList.add('visible');
      setTimeout(() => {
        setTimeout(() => {
          document.querySelector(".movingtext__text").classList.add('visible');
          document.querySelector(".welcome__text").classList.add('visible');
          setTimeout(() => {
            document.querySelector(".welcome__year").classList.add('visible');
            document.querySelector(".header").classList.add('visible');
              setTimeout(() => {
              document.querySelector(".iservices__wrap").classList.add('visible');
            }, 444);
          }, 333);
        }, 333);
      }, 333);
    }, 555);
  }

  const contacts__wrap = document.querySelector(".contacts__wrap");
  if (contacts__wrap != null) {
    setTimeout(() => {
      document.querySelector(".header").classList.add('visible');
    }, 333);
    
  }
  const services__folio = document.querySelector(".services__folio");
  if (services__folio != null) {
    document.querySelector(".services__title h1").classList.add('visible');
    setTimeout(() => {
      document.querySelector(".services__intro__wrap").classList.add('visible');
      setTimeout(() => {
        document.querySelector(".services__blink").classList.add('visible');
      }, 333);
    }, 666);
    setTimeout(() => {
      document.querySelector(".header").classList.add('visible');
    }, 333);
    
  }contacts__wrap

  const clients__head = document.querySelector(".clients");
  if (clients__head != null) {
    document.querySelector(".clients h1").classList.add('visible');
    
    if (windowWidth1 <992) { 
      setTimeout(() => {
        const clients__list__item = document.querySelectorAll(".clients__list__item");
      
        clients__list__item.forEach(clients__item => {
          clients__item.classList.add('visible');
        })
      }, 666);
    }
    setTimeout(() => {
      document.querySelector(".header").classList.add('visible');
    }, 777);
    
  }
  const blog__head = document.querySelector(".blog__head");
  if (blog__head != null) {
    document.querySelector(".blog__head h1").classList.add('visible');
    setTimeout(() => {
      document.querySelector(".header").classList.add('visible');
    }, 333);
    
  }
  
  const portfolio__nav = document.querySelector(".portfolio__nav");
  if (portfolio__nav != null) {
    document.querySelector(".portfolio__head h1").classList.add('visible');
    document.querySelector(".portfolio__head .h2").classList.add('visible');
    document.querySelector(".contentHead__text").classList.add('visible');
    
    // setTimeout(() => {
    //   document.querySelector(".portfolio__nav").classList.add('visible');
    // }, 1777);
    setTimeout(() => {
      document.querySelector(".header").classList.add('visible');
    }, 1777);
    
  }

  
  const vacancies__head = document.querySelector(".vacancies__head");
  if (vacancies__head != null) {
    document.querySelector(".vacancies__head h1").classList.add('visible');
    document.querySelector(".vacancies__head .h2").classList.add('visible');
    document.querySelector(".contentHead__text").classList.add('visible');
    document.querySelector(".contentHead__mail").classList.add('visible');
    setTimeout(() => {
      document.querySelector(".header").classList.add('visible');
    }, 1333);
    
  }



  
  const article__head = document.querySelector(".article__head");
  if (article__head != null) {
    document.querySelector(".article__head h1").classList.add('visible');
    document.querySelector(".article__head__year").classList.add('visible');
    document.querySelector(".article__head__date").classList.add('visible');
    if (document.querySelector(".article__head__text") != null) {
      document.querySelector(".article__head__text").classList.add('visible');
    }
    if (document.querySelector(".article__head__tags") != null) {
      document.querySelector(".article__head__tags").classList.add('visible');

    }
    if (document.querySelector(".article__head__award") != null) {
      document.querySelector(".article__head__award").classList.add('visible');
      
    }
    
    setTimeout(() => {
      document.querySelector(".article__head__like").classList.add('visible');

    }, 1222);
    setTimeout(() => {
      document.querySelector(".header").classList.add('visible');
    }, 1444);
    
  }

  

  const candidateElement = document.getElementById("Ellipse_16_9_0");
  if (candidateElement != null) {

    const sourceIdNames = ["Ellipse_16_5","Ellipse_18_7","Ellipse_16_9","Ellipse_12_1_0","Ellipse_13_2_0","Ellipse_14_3_0","Ellipse_15_4_0","Ellipse_17_6_0","Ellipse_18_7_0","Ellipse_16_9_0"];
  

    candidateElement.addEventListener("animationend", (event) => {
      if (event.animationName === "animation_Ellipse_16_9_0_flow_5") {
  
        sourceIdNames.forEach((id, index) => {
          const element = document.getElementById(id)
        
          const animation = element.style.animation
        
          element.style.animation =  'none'
          setTimeout(() => {
            element.style.animation = animation
          }, 5) 
        })
      };
    });
  }

  const candidateElementBlog = document.getElementById("blog_Ellipse_17_6_0");

  if (candidateElementBlog != null) {
    const sourceIdNames = ["blog_Ellipse_12_1_0","blog_Ellipse_13_2_0","blog_Ellipse_14_3_0","blog_Ellipse_15_4_0","blog_Ellipse_16_5_0","blog_Ellipse_17_6_0"];
    

    candidateElementBlog.addEventListener("animationend", (event) => {
      if (event.animationName === "animation_blog_Ellipse_17_6_0_flow_5") {
        sourceIdNames.forEach((id, index) => {
          const element = document.getElementById(id)
        
          const animation = element.style.animation
        
          element.style.animation =  'none'
          setTimeout(() => {
            element.style.animation = animation
          }, 5) 
        })
      };
    });
  }
  const candidateElementMain = document.getElementById("main_Ellipse_17_6_0");
  if (candidateElementMain != null) {
    const sourceIdNames = ["main_Ellipse_12_1_0","main_Ellipse_13_2_0","main_Ellipse_14_3_0","main_Ellipse_15_4_0","main_Ellipse_16_5_0","main_Ellipse_17_6_0"];
    

    candidateElementMain.addEventListener("animationend", (event) => {
      if (event.animationName === "animation_main_Ellipse_17_6_0_flow_5") {

        sourceIdNames.forEach((id, index) => {
          const element = document.getElementById(id)
        
          const animation = element.style.animation
        
          element.style.animation =  'none'
          setTimeout(() => {
            element.style.animation = animation
          }, 5) 
        })
      };
    });
  }

})